import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import "./style.css"
import { useTheme } from "../../global-components/src";
import { useEffect } from "react";
import ItemList from "../../components/ItemList/ItemList";

const Design = () => {
    const{ 
        toggleNewUi, isNewUI, 
        toggleNewPacoca, isNewPacoca, 
        togglePacocagram, isPacocagram, 
        toggleHideCensorship, hideCensorship, 
        toggleHideMenuMobile, hideMenuMobile,
        toggleIsLiquidGlass, isLiquidGlass,
        toggleBlueTheme, isBlueTheme,
        toggleHideBranToken, hideBranToken,
        toggleHideChatGlobal, hideChatGlobal,
    } = useTheme();

    return (
        <>
            <Screen paddingTopTitle={true} title="Design">
                <Helmet>
                        <title>Paçoca - Design</title>
                        <meta name="description" content={`Paçoca - Design, configure notificações, privacidade, sessões ativas doação, termos de uso, diretrizes, significado dos selos!`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, Design, privacidade, termos de uso, doação, diretrizes, conexões, notificações, digitais}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - Design - Rede Social`}/>
                        <meta property="og:description" content={`Paçoca - Design, configure notificações, privacidade, sessões ativas doação, termos de uso, diretrizes, significado dos selos momentos!`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - Design - Rede Social`}/>
                        <meta name="twitter:description" content={`Paçoca - Design, configure notificações, privacidade, sessões ativas doação, termos de uso, diretrizes, significado dos selos momentos!`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <div className="padding-big-screen">
                    <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                        <input onChange={toggleNewUi} checked={isNewUI} className="form-check-input" type="checkbox" id="new_ui" name="new_ui"/>
                        <label onChange={toggleNewUi} className="form-check-label cursor-pointer" htmlFor="new_ui"><h5 style={{margin: 0}}>Menu preto ou branco</h5></label>
                    </div>
                    <p>Menu em preto ou branco, de acordo com o dark mode</p>
                </div>

                <div className="padding-big-screen">
                    <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                        <input onChange={toggleNewPacoca} checked={isNewPacoca} className="form-check-input" type="checkbox" id="new_pacoca" name="new_pacoca"/>
                        <label onChange={toggleNewPacoca} className="form-check-label cursor-pointer" htmlFor="new_pacoca"><h5 style={{margin: 0}}>Novo UI</h5></label>
                    </div>
                    <p>Interface atualizada do Paçoca</p>
                </div>

                <div className="padding-big-screen">
                    <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                        <input onChange={togglePacocagram} checked={isPacocagram} className="form-check-input" type="checkbox" id="pacocagram" name="pacocagram"/>
                        <label onChange={togglePacocagram} className="form-check-label cursor-pointer" htmlFor="pacocagram"><h5 style={{margin: 0}}>Paçocagram</h5></label>
                    </div>
                    <p>Deixa textos menores e abaixo das imagens</p>
                </div>

                <div className="padding-big-screen">
                    <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                        <input onChange={toggleBlueTheme} checked={isBlueTheme} className="form-check-input" type="checkbox" id="blue_theme" name="blue_theme"/>
                        <label onChange={toggleBlueTheme} className="form-check-label cursor-pointer" htmlFor="blue_theme"><h5 style={{margin: 0}}>Tema Azul</h5></label>
                    </div>
                    <p>Ativa o tema azul do Paçoca</p>
                </div>
                
                {window.innerWidth <850 && (
                    <div className="padding-big-screen">
                        <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                            <input onChange={toggleHideMenuMobile} checked={hideMenuMobile} className="form-check-input" type="checkbox" id="hide_menu_mobile" name="hide_menu_mobile"/>
                            <label onChange={toggleHideMenuMobile} className="form-check-label cursor-pointer" htmlFor="hide_menu_mobile"><h5 style={{margin: 0}}>Esconder menu</h5></label>
                        </div>
                        <p>Esconde menu ao rolar feed</p>
                    </div>
                )}
                
                {window.innerWidth <850 && (
                    <div className="padding-big-screen">
                        <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                            <input onChange={toggleIsLiquidGlass} checked={isLiquidGlass} className="form-check-input" type="checkbox" id="is_liquid_glass" name="is_liquid_glass"/>
                            <label onChange={toggleIsLiquidGlass} className="form-check-label cursor-pointer" htmlFor="is_liquid_glass"><h5 style={{margin: 0}}>Liquid Glass Glass</h5></label>
                        </div>
                        <p>Ativa o Liquid Glass do iOS, funciona para Android também</p>
                    </div>
                )}

                <div className="padding-big-screen">
                    <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                        <input onChange={toggleHideCensorship} checked={hideCensorship} className="form-check-input" type="checkbox" id="hide_censorship" name="hide_censorship"/>
                        <label onChange={toggleHideCensorship} className="form-check-label cursor-pointer" htmlFor="hide_censorship"><h5 style={{margin: 0}}>Ocultar Censura</h5></label>
                    </div>
                    <p>Remove censura de palavras</p>
                </div>

                <div className="padding-big-screen">
                    <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                        <input onChange={toggleHideBranToken} checked={!hideBranToken} className="form-check-input" type="checkbox" id="hide_bran_token" name="hide_bran_token"/>
                        <label onChange={toggleHideBranToken} className="form-check-label cursor-pointer" htmlFor="hide_bran_token"><h5 style={{margin: 0}}>Mostrar Tokens</h5></label>
                    </div>
                    <p>Mostra Farelo Tokens no feed e tempo de mineração</p>
                </div>

                <div className="padding-big-screen">
                    <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                        <input onChange={toggleHideChatGlobal} checked={!hideChatGlobal} className="form-check-input" type="checkbox" id="hide_global_chat" name="hide_global_chat"/>
                        <label onChange={toggleHideChatGlobal} className="form-check-label cursor-pointer" htmlFor="hide_global_chat"><h5 style={{margin: 0}}>Mostrar Chat Global</h5></label>
                    </div>
                    <p>Mostra icone de chat global</p>
                </div>
            </Screen>
        </>
    );
};

export default Design;